import React from "react";
import MUIDataTable from "mui-datatables";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const MuiTable = (props) => {
  const { data, options, onView, onEdit, onDelete } = props;
  const { columns, rows } = data;
  let temp = [];


  rows.forEach((element) => {
    temp.push({
      ...element,
      actions: [
        <div>
          {onEdit && (
            <IconButton onClick={() => onEdit(element)} aria-label="edit" component="span">
              <EditIcon />
            </IconButton>
          )}

          {onDelete && (
            <IconButton onClick={() => onDelete(element)} aria-label="delete" component="span">
              <DeleteIcon />
            </IconButton>
          )}

          {onView && (
            <IconButton onClick={() => onView(element)} aria-label="view" component="span">
              <VisibilityIcon />
            </IconButton>
          )}
        </div>,
      ],
    });
  });

  const processedColumns = (columns || []).map((col, idx) => {
    const columnObj = typeof col === "string" ? { name: col, label: col } : { ...col };
    const existingOptions = columnObj.options || {};

    if (!existingOptions.customHeadRender) {
      existingOptions.customHeadRender = (columnMeta) => {
        return (
          <th
            key={columnMeta.index}
            style={{
              fontWeight: 500,        
              textAlign: "left",      
              padding: "8px",
              border: "1px solid #ddd",
              background: "#f7f7f7",
            }}
          >
            {columnObj.label ?? columnObj.name}
          </th>
        );
      };
    }

    return { ...columnObj, options: existingOptions };
  });

  const getMuiTheme = () =>
    createTheme({
      components: {
        MuiTableCell: {
          styleOverrides: {
            head: {
              fontWeight: 500,
              textAlign: "left", 
            },
            root: {
              padding: "8px",
              border: "1px solid #ddd",
            },
          },
        },
        MuiTableSortLabel: {
          styleOverrides: {
            root: {
              fontWeight: 500,
              textAlign: "left",
            },
          },
        },
      },
    });

  return (
    <ThemeProvider theme={getMuiTheme()}>
      <MUIDataTable
        title={""}
        data={temp}
        columns={processedColumns}
        options={options}
      />
    </ThemeProvider>
  );
};

export default MuiTable;
